import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useOnline } from '../../lib/online';
import { onBanner } from '../../lib/sync';

export function SyncBanner() {
  const online = useOnline();
  const { t } = useTranslation('common');
  const [info, setInfo] = useState<{ queuedCount: number; draining: boolean }>({ queuedCount: 0, draining: false });

  useEffect(() => {
    onBanner((i) => setInfo(i));
  }, []);

  if (online && !info.draining) return null;

  if (online && info.draining) {
    return (
      <div role="status" className="bg-[var(--status-success-bg)] text-[var(--status-success-fg)] text-sm py-2 px-4 text-center">
        {t('syncing', { count: info.queuedCount })}
      </div>
    );
  }

  if (info.queuedCount > 0) {
    return (
      <div role="status" className="bg-[var(--status-warning-bg)] text-[var(--status-warning-fg)] text-sm py-2 px-4 text-center">
        {t('queued_offline', { count: info.queuedCount })}
      </div>
    );
  }
  return (
    <div role="status" className="bg-[var(--status-warning-bg)] text-[var(--status-warning-fg)] text-sm py-2 px-4 text-center">
      {t('queued_offline_empty')}
    </div>
  );
}
